import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, AbstractControl } from '@angular/forms'

@Component({
  selector: 'form-input-text',
  templateUrl: './form-input-text.component.html',
  styleUrls: ['./form-input-text.component.scss']
})
export class FormInputTextComponent implements OnInit {


  @Input() descricao: String;

  @Input() nameControl: String;

  @Input() validador: AbstractControl;

  @Input() form: FormGroup;

  @Input() obrigatorio: boolean = false;

  @Input() mascara: Object;

  @Input() placeholder: String = "";

  @Output("valor") valorAlterado: EventEmitter<string> = new EventEmitter<string>();

  private valorCampo: string;


  @Input()
  get valor() {
    if (this.valorCampo) {
      this.valorCampo = this.valorCampo.trim();
    } else {
      this.valorCampo = null;
    }

    return this.valorCampo;
  }

  set valor(valor) {
    if (valor) {
      this.valorCampo = valor.trim();
    } else {
      this.valorCampo = null;
    }
    this.valorAlterado.emit(this.valorCampo);
  }

  ngOnInit() {

    Object.keys(this.form.controls).forEach(control => {
      if (control == this.nameControl) {
        this.validador = this.form.controls[control];
      }
    });


  }

}



// WEBPACK FOOTER //
// C:/Disco D/Projetos/central-cliente/src/app/angular-base-ui/form-input-text/form-input-text.component.ts